import { Store } from '@stores/Store'
import { I18nKey } from '@utils/i18n'

export class LocalizationHelper {
  store!: Store

  constructor(store: Store) {
    this.store = store
  }

  // Version labels, one getter per registry year (VersionPanel indexes by
  // option.year). A future calculation version adds its own getter here plus
  // an INCOME_SIMULATOR_VERSION_<year> translation row. Deliberately explicit,
  // no year derivation, the performance year differs from the calendar year.

  get 2025(): I18nKey {
    return 'INCOME_SIMULATOR_VERSION_2025'
  }

  // Path to Bronze

  // Launch-year eligibility window for all markets EXCEPT AU/NZ, which use the
  // evergreen "last Performance Year" wording from day one (Amway, 2026-08-10).
  // From Sep 2027 ALL markets switch to the evergreen key, flip this getter
  // to always return PATH_TO_BRONZE_ELIGIBILITY_ANZ with the PY28 update.
  get PATH_TO_BRONZE_ELIGIBILITY_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'PATH_TO_BRONZE_ELIGIBILITY_ANZ' : 'PATH_TO_BRONZE_ELIGIBILITY'
  }


  // Performance Plus

  get PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT_ANZ' : 'PERFORMANCE_PLUS_GROUP_PV_REQUIREMENT'
  }

  get PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT_ANZ' : 'PERFORMANCE_PLUS_GROUP_PV_LEG_REQUIREMENT'
  }

  get INFO_PERFORMANCE_PLUS_KEY(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'INFO_NEW_PERFORMANCE_PLUS_ANZ' : 'INFO_NEW_PERFORMANCE_PLUS_EU'
  }

  // Summary Core Plan Income
  get RUBY_BONUS_TOOLTIP(): I18nKey {
    const { selectedANZ } = this.store
    return selectedANZ ? 'RUBY_BONUS_TOOLTIP_ANZ' : 'RUBY_BONUS_TOOLTIP'
  }

}
